import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'
import {
    Divider,
    StyledNightlyEditionButtonContainer,
    StyledNightlyEditionContent,
    StyledNightlyEditionPicture,
    StyledNightlyEditionTextContainer,
} from '../SpecificEdition/NightlySpecificEdition.styled'

export const HeaderContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
})

export const StyledNightlyEditionTextContainerLeft = styled(
    StyledNightlyEditionTextContainer,
)(({}) => ({
    [breakpoint('sm')]: {
        gridColumn: '1 / span 1',
    },
}))

export const StyledNightlyEditionPictureRight = styled(
    StyledNightlyEditionPicture,
)(({ theme }) => ({
    [breakpoint('sm')]: {
        gridColumn: '2 / span 1',
    },
}))

export const StyledNightlyEditionButtonContainerLeft = styled(
    StyledNightlyEditionButtonContainer,
)(() => ({
    [breakpoint('sm')]: {
        gridColumn: '1 / span 1',
        width: '100%',
    },
    [breakpoint('lg')]: {
        width: '100%',
    },
}))

export const StyledNightlyEditionContentHome = styled(
    StyledNightlyEditionContent,
)(({ theme }) => ({
    paddingTop: calcRem(68),

    [breakpoint('sm')]: {
        padding: calcRem(68, 0, 0, 0),
    },
}))

export const StyledDivider = styled(Divider)({
    marginTop: calcRem(68),
})
